import { render } from "./PaginationComponent.vue?vue&type=template&id=40ec06f5"
import script from "./PaginationComponent.vue?vue&type=script&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&lang=js"
script.render = render

export default script